export const chainMap: any = {
    'ronin': 'Ronin',
    'matic': 'Polygon',
    'mainnet': 'Ethereum',
    'cypress': 'Klaytn',
    'bscMainnet': 'Binance',
    'bora': 'Bora',
};
